// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as ReactIf from "react-if";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as UseApi$Showside from "../hook/UseApi.bs.js";
import * as PDPForm$Showside from "../components/PDPForm.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as StoreId$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/Store/StoreId.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as Namespace$Showside from "../types/Namespace.bs.js";
import * as PDPNavbar$Showside from "../components/PDPNavbar.bs.js";
import * as PDPContent$Showside from "../components/PDPContent.bs.js";
import * as UseQuantity$Showside from "../hook/UseQuantity.bs.js";
import * as UseTracking$Showside from "../hook/UseTracking.bs.js";
import * as BaseWithTheme$Showside from "../context/BaseWithTheme.bs.js";
import * as ErrorBoundary$Showside from "../utils/ErrorBoundary.bs.js";
import * as ErrorReporter$Showside from "../components/ErrorReporter.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as StoreCategory$Showside from "../types/StoreCategory.bs.js";
import * as LocationConfig$Showside from "../utils/LocationConfig.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as RollbarInstance$Showside from "../utils/RollbarInstance.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as LauncherApp_Lazy$Showside from "../apps/LauncherApp_Lazy.bs.js";
import * as PDPContentMobile$Showside from "../components/PDPContentMobile.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as PDPContentDesktop$Showside from "../components/PDPContentDesktop.bs.js";
import * as PausePageScrolling$Showside from "../components/PausePageScrolling.bs.js";
import * as UseDisplayVariantBy$Showside from "../hook/UseDisplayVariantBy.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as ProductDetailsContext$Showside from "../context/ProductDetailsContext.bs.js";
import * as UserSavedProductsProvider$Showside from "../context/UserSavedProductsProvider.bs.js";
import * as StickyHeaderOffsetProvider$Showside from "../context/StickyHeaderOffsetProvider.bs.js";
import * as LegacyShowside_CategoryDecoders$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/LegacyShowside/LegacyShowside_CategoryDecoders.bs.js";
function ProductDetailsPage$PDPWrapper(Props) {
  var children = Props.children;
  var product = Props.product;
  var variant = Props.variant;
  var productCategory = Props.productCategory;
  var quantity = Props.quantity;
  var match = ConfigurationProvider$Showside.use(undefined);
  var settings = match.config.settings;
  var match$1 = EntrypointContext$Showside.use(undefined);
  var onOpenLink = match$1.onOpenLink;
  var onAddToCart = match$1.onAddToCart;
  var match$2 = RouterProvider$Showside.useRouter(undefined);
  var listPageType = match$2.listPageType;
  var goTo = match$2.goTo;
  var route = match$2.route;
  var handleFormChange = function (product$1, variant) {
    if (typeof route !== "number" && route.TAG === /* QuickView */3) {
      var payload = route._0;
      return Curry._3(goTo, undefined, true, {
        TAG: /* QuickView */3,
        _0: {
          mediaId: payload.mediaId,
          mediaParentId: payload.mediaParentId,
          albumId: payload.albumId,
          productId: product.id,
          relatedMediaProductIds: payload.relatedMediaProductIds,
          relatedMediaCategoryId: payload.relatedMediaCategoryId,
          variantId: Belt_Option.map(variant, function (param) {
            return param.id;
          }),
          panelClosed: payload.panelClosed,
          zoomedPhotoIndex: payload.zoomedPhotoIndex,
          time: payload.time
        }
      });
    }
    Curry._3(goTo, undefined, true, {
      TAG: /* PDP */2,
      _0: {
        categoryId: Belt_Option.flatMap(listPageType, function (id) {
          if (typeof id === "number" || id.TAG !== /* Category */0) {
            return;
          } else {
            return id._0;
          }
        }),
        productCategoryId: product.categoryId,
        productId: product.id,
        variantId: Belt_Option.map(variant, function (param) {
          return param.id;
        }),
        zoomedPhotoIndex: undefined
      }
    });
  };
  var handleFormSubmit = function (submission) {
    var submitButtonType;
    submitButtonType = submission.TAG === /* AllGood */0 ? submission._0.submitButtonType : undefined;
    var quantity$1 = Belt_Option.getWithDefault(quantity, 1);
    if (submitButtonType === undefined) {
      return Promise.resolve(undefined);
    }
    if (typeof submitButtonType === "number") {
      if (submitButtonType !== 0) {
        Curry._5(onOpenLink, undefined, undefined, product, variant, undefined);
        return Promise.resolve(undefined);
      } else {
        Curry._4(onAddToCart, product, variant, quantity$1, productCategory);
        return new Promise(function (resolve, reject) {
          setTimeout(function (param) {
            resolve(settings.pdpAddToCartConfirmation);
          }, 1000);
        });
      }
    }
    var confirmation = submitButtonType.confirmation;
    Curry._3(submitButtonType.run, product, variant, quantity$1);
    if (confirmation !== undefined) {
      return new Promise(function (resolve, reject) {
        setTimeout(function (param) {
          resolve(confirmation);
        }, 1000);
      });
    } else {
      return Promise.resolve(undefined);
    }
  };
  return React.createElement(PDPForm$Showside.make, PDPForm$Showside.makeProps(product, variant, undefined, settings.hideOutOfStock, handleFormChange, handleFormSubmit, React.createElement(ProductDetailsContext$Showside.Provider.make, {
    product: product,
    variant: variant,
    children: children
  }), undefined, undefined));
}
ProductDetailsPage$PDPWrapper.displayName = "ProductDetailsPage.PDPWrapper";
var PDPWrapper = {
  make: ProductDetailsPage$PDPWrapper
};
function isShopifyCollectionId(str) {
  return Belt_Option.isSome(Caml_option.null_to_opt(str.match(/^\d+$/)));
}
function useProductCategory(smartnavApiHost, storeId, productId, activeCategory, route) {
  var productCategoryId;
  if (typeof route === "number" || route.TAG !== /* PDP */2) {
    productCategoryId = undefined;
  } else {
    var productCategoryId$1 = route._0.productCategoryId;
    productCategoryId = Caml_obj.notequal(productCategoryId$1, "") ? productCategoryId$1 : undefined;
  }
  var match = UseApi$Showside.useCategoriesByProduct(smartnavApiHost, storeId, activeCategory !== undefined || productCategoryId !== undefined ? undefined : productId, undefined);
  var productCategories = Belt_Option.getWithDefault(Belt_Option.flatMap(match.data, function (page) {
    return page.categories;
  }), []);
  var match$1 = productCategories.length;
  var firstProductCategory = match$1 === 0 || match$1 === 1 ? Belt_Array.get(productCategories, 0) : Belt_Array.get(Belt_Array.keep(productCategories, function (category) {
    return Curry._1(StoreId$ApiTypes.CategoryId.toString, category.id) !== "all";
  }), 0);
  var match$2 = UseApi$Showside.useCategory(smartnavApiHost, storeId, activeCategory !== undefined ? undefined : Belt_Option.keep(Belt_Option.orElse(productCategoryId, Belt_Option.map(firstProductCategory, function (c) {
    return Curry._1(StoreId$ApiTypes.CategoryId.toString, c.id);
  })), isShopifyCollectionId), undefined);
  return Belt_Option.map(Belt_Option.orElse(match$2.data, firstProductCategory), StoreCategory$Showside.toShowsideCategory);
}
function ProductDetailsPage(Props) {
  var viewport = Props.viewport;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var shouldForceMobileOpt = Props.shouldForceMobile;
  var isInsideQuickViewOpt = Props.isInsideQuickView;
  var config = Props.config;
  var productId = Props.productId;
  var showMoreProducts = Props.showMoreProducts;
  var shouldForceMobile = shouldForceMobileOpt !== undefined ? shouldForceMobileOpt : false;
  var isInsideQuickView = isInsideQuickViewOpt !== undefined ? isInsideQuickViewOpt : false;
  PausePageScrolling$Showside.usePausePageScrolling(undefined);
  var displayVariantBy = UseDisplayVariantBy$Showside.useDisplayVariantBy(undefined);
  var match = ConfigurationProvider$Showside.use(undefined);
  var match$1 = match.config;
  var account = match$1.transitiveAccount;
  var storeId = match$1.transitiveStoreId;
  var settings = match$1.settings;
  var configId = match$1.id;
  var activeCategory = RouterProvider$Showside.useActiveCategory(true, undefined, match$1.categories);
  var scrollToRef = React.useRef(function (param) {});
  var match$2 = React.useState(function () {});
  var setClickedProduct = match$2[1];
  var clickedProduct = match$2[0];
  var fallbackScrollableContainerRef = React.useRef(null);
  var fallbackViewportRef = React.useRef(null);
  var viewport$1 = viewport !== undefined ? viewport : fallbackViewportRef;
  var match$3 = EntrypointContext$Showside.use(undefined);
  var onBackClick = match$3.onBackClick;
  var onProductClick = match$3.onProductClick;
  var trackEvent = match$3.trackEvent;
  var embedType = match$3.embedType;
  var smartnavApiHost = match$3.smartnavApiHost;
  var match$4 = ViewportContext$Showside.use(undefined);
  var isMobile = match$4.isMobile;
  var match$5 = UserSavedProductsProvider$Showside.use(undefined).history;
  var addToHistory = match$5.add;
  var match$6 = RouterProvider$Showside.useRouter(undefined);
  var anyVariantId = match$6.anyVariantId;
  var anyProductId = match$6.anyProductId;
  var listPageType = match$6.listPageType;
  var route = match$6.route;
  var productId$1;
  if (productId !== undefined) {
    productId$1 = productId;
  } else if (typeof route === "number") {
    productId$1 = anyProductId;
  } else {
    switch (route.TAG | 0) {
      case /* PDP */2:
        productId$1 = isInsideQuickView ? anyProductId : route._0.productId;
        break;
      case /* QuickView */3:
        productId$1 = isInsideQuickView ? route._0.productId : anyProductId;
        break;
      default:
        productId$1 = anyProductId;
    }
  }
  React.useEffect(function () {
    if (productId$1 !== undefined) {
      if (activeCategory !== undefined) {
        if (Caml_obj.notequal(Category$Showside.ExternalConnection.getConnection(activeCategory), /* History */0)) {
          Curry._1(addToHistory, {
            TAG: /* ProductId */1,
            _0: productId$1
          });
        }
      } else if (Caml_obj.notequal(listPageType, /* History */1)) {
        Curry._1(addToHistory, {
          TAG: /* ProductId */1,
          _0: productId$1
        });
      }
    }
  }, [productId$1]);
  var productId$2 = Belt_Option.getWithDefault(productId$1, "");
  var variantId;
  if (typeof route === "number") {
    variantId = anyVariantId;
  } else {
    switch (route.TAG | 0) {
      case /* PDP */2:
        variantId = isInsideQuickView ? anyVariantId : route._0.variantId;
        break;
      case /* QuickView */3:
        variantId = isInsideQuickView ? route._0.variantId : anyVariantId;
        break;
      default:
        variantId = anyVariantId;
    }
  }
  var stickyHeaderOffset = StickyHeaderOffsetProvider$Showside.useLenient(undefined);
  var firstProductCategory = useProductCategory(smartnavApiHost, storeId, productId$2, activeCategory, route);
  var activeCategory$1 = Belt_Option.getWithDefault(Belt_Option.orElse(Belt_Option.orElse(activeCategory, Belt_Option.keep(settings.indexNode, Category$Showside.ExternalConnection.isConnectedToStoreCategory)), firstProductCategory), LegacyShowside_CategoryDecoders$ApiTypes.empty);
  var scrollableContainerRef$1 = Belt_Option.getWithDefault(scrollableContainerRef, fallbackScrollableContainerRef);
  var customOnProductClick = React.useCallback(function (product) {
    return function (variant) {
      Curry.app(trackEvent, ["slider:item", true, activeCategory$1, product, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
      if (isMobile || shouldForceMobile) {
        if (product.id !== productId$2) {
          return Curry._1(setClickedProduct, function (param) {
            return product;
          });
        } else {
          return;
        }
      } else {
        return Curry._2(onProductClick, product, variant);
      }
    };
  }, [trackEvent, activeCategory$1, isMobile, shouldForceMobile, setClickedProduct, onProductClick, productId$2]);
  var pdpCategory = React.useMemo(function () {
    return Category$Showside.setChildren(activeCategory$1, []);
  }, [activeCategory$1]);
  var product = clickedProduct !== undefined ? clickedProduct : undefined;
  var match$7 = UseApi$Showside.useProductById(false, pdpCategory.id, smartnavApiHost, match$3.market, productId$2);
  var productFromCache = match$7.product;
  var product$1 = product !== undefined ? product : productFromCache;
  var partial_arg = settings.hideOutOfStock;
  var selectedVariant = Belt_Option.map(product$1, function (param) {
    return Product$Showside.getInitialDisplayVariant(partial_arg, variantId, displayVariantBy, param);
  });
  var match$8 = UseQuantity$Showside.useQuantity(undefined, product$1, selectedVariant);
  var setQuantity = match$8[1];
  var quantity = match$8[0];
  React.useEffect(function () {
    if (product$1 !== undefined) {
      var tmp;
      tmp = typeof route === "number" || route.TAG !== /* QuickView */3 ? undefined : route._0.mediaId;
      Curry.app(trackEvent, ["product details:open", undefined, undefined, product$1, selectedVariant, undefined, undefined, undefined, tmp, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    }
  }, [Belt_Option.map(product$1, function (product) {
    return product.id;
  })]);
  var product$2 = React.useMemo(function () {
    return product$1;
  }, [Belt_Option.map(product$1, function (p) {
    return p.id;
  })]);
  var variant = React.useMemo(function () {
    return selectedVariant;
  }, [Belt_Option.map(selectedVariant, function (v) {
    return v.id;
  })]);
  React.useEffect(function () {
    if (product$2 !== undefined && variant !== undefined) {
      UseTracking$Showside.trackRetargeting(account, configId, pdpCategory, product$2, variant, isMobile, undefined, undefined, 1, undefined, undefined, "view_item");
    }
  }, [Belt_Option.map(product$2, function (product) {
    return product.id;
  })]);
  var clickedProductId = Belt_Option.map(clickedProduct, function (clickedProduct) {
    return clickedProduct.id;
  });
  var hasClickedOtherProductOnMobile = (isMobile || shouldForceMobile) && clickedProductId !== undefined && Caml_obj.notequal(clickedProductId, productId$2);
  if (hasClickedOtherProductOnMobile) {
    Curry._1(scrollToRef.current, /* Top */0);
  }
  var onScroll = React.useCallback(function ($$event) {
    return function (param) {
      if (!(isMobile || shouldForceMobile)) {
        return;
      }
      var target = $$event.target;
      var scrollTop = target.scrollTop | 0;
      if (scrollTop === 0 && clickedProductId !== undefined && Caml_obj.notequal(clickedProductId, productId$2)) {
        Curry._1(setClickedProduct, function (param) {});
        if (clickedProduct !== undefined) {
          return Curry._2(onProductClick, clickedProduct, undefined);
        } else {
          return;
        }
      }
    };
  }, [clickedProductId, productId$2, clickedProduct, isMobile, shouldForceMobile]);
  var renderPDPControls = function (param) {
    var shouldRender = isMobile || !isInsideQuickView;
    var showNavbar = shouldRender && !(isMobile && settings.newMobilePDP) && embedType !== /* ProductDetailsPage */5;
    var closeButton = !isMobile && settings.desktopPDPLayout === /* Old */0;
    if (showNavbar) {
      return React.createElement(PDPNavbar$Showside.make, {
        close: closeButton
      });
    } else {
      return null;
    }
  };
  var renderLauncher = embedType >= 5 && !isInsideQuickView ? function (className) {
    return React.createElement(LocationConfig$Showside.Provider.make, {
      namespace: Namespace$Showside.fromString("pl"),
      children: React.createElement(RouterProvider$Showside.make, {
        configId: configId,
        embedType: /* Launcher */2,
        children: React.createElement(StickyHeaderOffsetProvider$Showside.make, {
          children: React.createElement(LauncherApp_Lazy$Showside.make, {
            configId: configId,
            embedType: /* Launcher */2,
            className: className
          })
        })
      })
    });
  } : undefined;
  var match$9 = settings.newMobilePDP;
  var match$10 = settings.desktopPDPLayout;
  var tmp;
  var exit = 0;
  if (product$2 !== undefined && variant !== undefined) {
    var exit$1 = 0;
    var exit$2 = 0;
    if (match$9 && isMobile) {
      var tmp$1 = {
        product: product$2,
        variant: variant,
        productCategory: pdpCategory,
        shouldForceMobile: shouldForceMobile,
        settings: settings,
        isInsideQuickView: isInsideQuickView,
        routeProductId: productId$2,
        viewport: viewport$1,
        scrollableContainerRef: scrollableContainerRef$1,
        scrollToRef: scrollToRef,
        onProductClick: customOnProductClick,
        onScroll: onScroll,
        quantity: quantity,
        setQuantity: setQuantity
      };
      if (variantId !== undefined) {
        tmp$1.routeVariantId = variantId;
      }
      if (config !== undefined) {
        tmp$1.config = Caml_option.valFromOption(config);
      }
      if (showMoreProducts !== undefined) {
        tmp$1.showMoreProducts = Caml_option.valFromOption(showMoreProducts);
      }
      if (renderLauncher !== undefined) {
        tmp$1.renderLauncher = Caml_option.valFromOption(renderLauncher);
      }
      tmp = React.createElement(ProductDetailsPage$PDPWrapper, {
        children: React.createElement(PDPContentMobile$Showside.make, tmp$1),
        product: product$2,
        variant: variant,
        productCategory: pdpCategory,
        quantity: quantity
      });
    } else {
      exit$2 = 3;
    }
    if (exit$2 === 3) {
      if (match$10 !== 0 && !(isMobile || isInsideQuickView)) {
        var tmp$2 = {
          product: product$2,
          variant: variant,
          productCategory: pdpCategory,
          shouldForceMobile: shouldForceMobile,
          isInsideQuickView: isInsideQuickView,
          routeProductId: productId$2,
          viewport: viewport$1,
          scrollableContainerRef: scrollableContainerRef$1,
          scrollToRef: scrollToRef,
          onProductClick: customOnProductClick,
          onScroll: onScroll,
          quantity: quantity,
          setQuantity: setQuantity
        };
        if (variantId !== undefined) {
          tmp$2.routeVariantId = variantId;
        }
        if (showMoreProducts !== undefined) {
          tmp$2.showMoreProducts = Caml_option.valFromOption(showMoreProducts);
        }
        if (renderLauncher !== undefined) {
          tmp$2.renderLauncher = Caml_option.valFromOption(renderLauncher);
        }
        tmp = React.createElement(ProductDetailsPage$PDPWrapper, {
          children: React.createElement(PDPContentDesktop$Showside.make, tmp$2),
          product: product$2,
          variant: variant,
          quantity: quantity
        });
      } else {
        exit$1 = 2;
      }
    }
    if (exit$1 === 2) {
      var tmp$3 = {
        product: product$2,
        variant: variant,
        productCategory: pdpCategory,
        shouldForceMobile: shouldForceMobile,
        isInsideQuickView: isInsideQuickView,
        viewport: viewport$1,
        scrollableContainerRef: scrollableContainerRef$1,
        scrollToRef: scrollToRef,
        onProductClick: customOnProductClick,
        onScroll: onScroll,
        quantity: quantity,
        setQuantity: setQuantity
      };
      if (showMoreProducts !== undefined) {
        tmp$3.showMoreProducts = Caml_option.valFromOption(showMoreProducts);
      }
      if (renderLauncher !== undefined) {
        tmp$3.renderLauncher = Caml_option.valFromOption(renderLauncher);
      }
      tmp = React.createElement(ProductDetailsPage$PDPWrapper, {
        children: React.createElement(PDPContent$Showside.make, tmp$3),
        product: product$2,
        variant: variant,
        quantity: quantity
      });
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = React.createElement(ConditionalRender$Showside.When.make, {
      condition: !match$7.isFetching,
      children: React.createElement(ErrorReporter$Showside.make, {
        error: Belt_Option.getWithDefault(match$7.error, RollbarInstance$Showside.makeError(Belt_Option.isNone(productFromCache), Belt_Option.getWithDefault(Belt_Option.flatMap(productFromCache, function (product) {
          if (Product$Showside.isOutOfStock(product)) {
            return "Product is out of stock.";
          }
        }), "An unexpected error occurred while loading product."))),
        extraInfo: {
          requestedStoreId: storeId,
          requestedProductId: productId$2,
          requestedVariantId: variantId,
          gotProductId: Belt_Option.map(product$2, function (product) {
            return product.id;
          }),
          gotVariantId: Belt_Option.map(variant, function (variant) {
            return variant.id;
          })
        },
        redirect: onBackClick,
        absolute: true
      })
    });
  }
  var content = React.createElement(React.Fragment, undefined, renderPDPControls(undefined), tmp);
  var fixedPositionPDP = embedType !== 0 ? !isInsideQuickView : false;
  var zIndex = embedType >= 5 ? "0" : settings.zIndex;
  return React.createElement(ErrorBoundary$Showside.make, {
    componentName: "PDP",
    redirect: onBackClick,
    children: React.createElement(ReactIf.If, {
      condition: fixedPositionPDP,
      children: null
    }, React.createElement(ReactIf.Then, {
      children: React.createElement(BaseWithTheme$Showside.make, {
        initiator: "pdp",
        portal: true,
        children: React.createElement("div", {
          ref: ReactDOMUtils$Showside.Ref.domRef(fallbackViewportRef),
          className: CSS$Showside.prefix("fixed left-0 w-full bg-main text-primary overflow-hidden select-none touch-none clip-path-bottom-xl"),
          style: {
            height: stickyHeaderOffset > 0 ? "calc(100% - " + CSS$Showside.intToPx(stickyHeaderOffset) + ")" : "100%",
            top: CSS$Showside.intToPx(stickyHeaderOffset),
            zIndex: zIndex,
            transform: "translate3d(0,0,0)"
          }
        }, content)
      })
    }), React.createElement(ReactIf.Else, {
      children: content
    }))
  });
}
ProductDetailsPage.displayName = "ProductDetailsPage";
var make = ProductDetailsPage;
var $$default = ProductDetailsPage;
export { PDPWrapper, isShopifyCollectionId, useProductCategory, make, $$default, $$default as default };
/* react Not a pure module */